import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { environment } from '../../environments/environment';
import { AvailabilityReportRow } from '../models/availability-report.model';

@Injectable({
  providedIn: 'root'
})
export class AvailabilityReportService {
  private apiUrl = `${environment.apiUrl}/AvailabilityReport`;

  constructor(private http: HttpClient) { }

  /**
   * Get availability report for a given year from the backend API
   * Returns data grouped by category and month (Jul-Dec)
   */
  getAvailabilityReport(year: number): Observable<AvailabilityReportRow[]> {
    return this.http.get<AvailabilityReportRow[]>(`${this.apiUrl}/${year}`);
  }
}


